import { render, staticRenderFns } from "./addstock.vue?vue&type=template&id=a7f72ba2&scoped=true"
import script from "./addstock.vue?vue&type=script&lang=js"
export * from "./addstock.vue?vue&type=script&lang=js"
import style0 from "./addstock.vue?vue&type=style&index=0&id=a7f72ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f72ba2",
  null
  
)

export default component.exports